<template>
  <div>
    <form-login v-if="this.$store.getters.getMultiOpt === 1"></form-login>
    <reset-password
      v-else-if="this.$store.getters.getMultiOpt === 2"
    ></reset-password>
  </div>
</template>

<script>
import FormLogin from "./FormLogin";
import ResetPassword from "./ResetPassword";
export default {
  name: "LoginTemplate",
  components: { ResetPassword, FormLogin }
};
</script>

<style scoped></style>
